import React from 'react';
import moment from 'moment';

const Date = ({value}) => <small>{value  ? moment(value).format('L LT') : null}</small>;

export default Date;